let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4l0XL")).then(() => parcelRequire('2jNnj'));